import {IMediaQueries} from "../media-queries.interface";
import {MediaQueriesBreakpoints} from "../media-queries-breakpoints";

function screenMediaQueryFor(mediaBreakpoint: string): string {
    return `@media ${mediaBreakpoint}`;
}

export const ScreenMediaQueries = Object.keys(MediaQueriesBreakpoints).reduce((result: any, breakpointKey) => {
    result[breakpointKey] = screenMediaQueryFor(MediaQueriesBreakpoints[breakpointKey as keyof IMediaQueries])
    return result;
}, {}) as IMediaQueries;